import { render, staticRenderFns } from "./orders-toolbar.vue?vue&type=template&id=0bb87ea8&"
import script from "./orders-toolbar.ts?vue&type=script&lang=ts&"
export * from "./orders-toolbar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports